import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import App from "./App";
import "./styles/index.css"; // This line loads all the Tailwind styles
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import QueryClientProvider from "./contexts/QueryClientProvider";
import * as Sentry from '@sentry/react'
import TawkController from "./components/common/TawkController";
import AppInitializer from "./components/common/AppInitializer.js";

Sentry.init({
  dsn: "https://9fb134445a67aed5bc413ddf8c55533e@o4510384928915456.ingest.de.sentry.io/4510384931340368",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
  blockAllMedia: false,
    }),
  Sentry.browserTracingIntegration(),
  Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0,
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.2,
  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  // tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  tracePropagationTargets: ["localhost", /^https:\/\/winguport\.jmpventuresltd\.com/],
  enableLogs: true,
});

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <QueryClientProvider>
      <AppInitializer>

      <BrowserRouter>
      <TawkController />
        {/* <AuthProvider> */}
          <App />
        {/* </AuthProvider> */}
      </BrowserRouter>
      </AppInitializer>
      <ToastContainer />
    </QueryClientProvider>
  </React.StrictMode>
);
